import { apiGet, ApiCallParams, apiPut, apiPost } from "../baseService";
import { VehicleCreateVm, VehicleVm, VehicleUpdateVm } from "./domain";

export async function getVehicleApi() {
  const response = await apiGet<VehicleVm>(`/api/vehicles`);

  if (response.data) {
    const result: VehicleVm = response.data;
    return result;
  }

  return undefined;
}

export async function postVehicleApi(params: ApiCallParams<VehicleCreateVm>) {
  const response = await apiPost(`/api/vehicles`, { payload: params });

  return response.data;
}

export async function putVehicleApi(params: ApiCallParams<VehicleUpdateVm>) {
  const response = await apiPut(`/api/vehicles`, { payload: params });

  return response.data;
}
